import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import axios from 'axios';
import { toast } from 'sonner';
import { Sparkle, CheckCircle } from '@phosphor-icons/react';
import { API } from '@/App';

const UniverseGenerating = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const intakeId = location.state?.intakeId;
  const [status, setStatus] = useState('analyzing');

  useEffect(() => {
    if (!intakeId) {
      toast.error('No intake data found');
      navigate('/intake');
      return;
    }

    generateUniverse();
  }, [intakeId]);

  const generateUniverse = async () => {
    try {
      setStatus('analyzing');
      await new Promise(resolve => setTimeout(resolve, 2000));
      
      setStatus('generating');
      const response = await axios.post(`${API}/universe/generate`, null, {
        params: { intake_id: intakeId }
      });
      
      setStatus('complete');
      await new Promise(resolve => setTimeout(resolve, 1500));
      
      navigate(`/universe/${response.data.id}`);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to generate universe');
      navigate('/intake');
    }
  };

  const statusMessages = {
    analyzing: 'Analyzing your business profile...',
    generating: 'Generating regulatory universe with AI risk scoring...',
    complete: 'Universe generated successfully!'
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <div className="text-center max-w-2xl">
        <motion.div
          animate={{
            rotate: status === 'complete' ? 0 : 360,
            scale: status === 'complete' ? 1.2 : 1
          }}
          transition={{
            rotate: { duration: 2, repeat: status === 'complete' ? 0 : Infinity, ease: "linear" },
            scale: { duration: 0.3 }
          }}
          className="inline-flex items-center justify-center w-24 h-24 mb-8"
        >
          {status === 'complete' ? (
            <CheckCircle size={96} weight="fill" className="text-gold" />
          ) : (
            <Sparkle size={96} weight="fill" className="text-gold" />
          )}
        </motion.div>

        <h1 className="text-3xl font-heading font-medium text-text-primary mb-4">
          {statusMessages[status]}
        </h1>

        {status !== 'complete' && (
          <div className="w-full max-w-md mx-auto mt-8">
            <div className="h-2 bg-background-surface rounded-full overflow-hidden">
              <motion.div
                initial={{ width: '0%' }}
                animate={{ width: status === 'analyzing' ? '40%' : '90%' }}
                transition={{ duration: 1.5 }}
                className="h-full bg-gold"
              />
            </div>
            <p className="text-sm text-text-tertiary mt-4">
              Powered by GPT-4o
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default UniverseGenerating;
